import { DependencyTokenCreator } from './types';

export const token: DependencyTokenCreator = <T>(description: string) => ({
  __t: null as unknown as T,
  id: Symbol(description),
  [Symbol.toPrimitive]() {
    return `[DependencyToken] ${description}`;
  },
});
